// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Yvd6","vLegacy":"SelectSecondary_vLegacy__2x0sR","error":"SelectSecondary_error__1_RS0","disabled":"SelectSecondary_disabled__9yyRl"};